import { combineReducers } from "redux";
import { mergeReducers } from "core/redux/decorators";
import * as api from "./api";

const getCurrentResume = mergeReducers(
  api.getCurrentResume.reducer,
  (state = {}, action) => {
    switch (action.type) {
      case api.updateResume.types.success:
        return {
          ...state,
          data: action.payload.body
        };
      default:
        return state;
    }
  }
);

export default combineReducers({
  api: combineReducers({
    editProfile: api.editProfile.reducer,
    editResume: api.updateResume.reducer,
    getCurrentResume: getCurrentResume,
    updateAvatar: api.updateAvatar.reducer
  })
});



// WEBPACK FOOTER //
// ./src/modules/user/profile/reducer.js